// extracted by extract-css-chunks-webpack-plugin
module.exports = {"filter-link":"_1pftVo","filter-link-active":"_3vEaTX"};